var liSimply = {
    shopid:6,
    interface:"https://ectappv2.eatcaketoday.com/interfaceStore",
    actions:{
      getProductData:"getProductData",
      checkLineItems:"checkLineItems"
      ,
    }
  };
  var checkout_selectors = ["input[name='checkout']", "button[name='checkout']", "input[name='goto_pp']", "button[name='goto_pp']", "input[name='goto_gc']", "button[name='goto_gc']", "[href$='checkout']"];
  $(document).ready(function(){
    addClickEvent();
    getOrderData(validateLineitems,false);
  });
  
  function getOrderData(callback,goToCheckout){
    $.fancybox.showLoading();
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        data = this.responseText;
        data = $.parseJSON(data);
        callback(data,goToCheckout);
      }
    };
    xhttp.open("GET", "/cart.json", true);
    xhttp.send();
  }
  
  function addClickEvent(){
    $(document).on("click",'#checkoutBtn', function(e) {
      e.preventDefault();
      getOrderData(validateLineitems,true);
    });
  
  }
  function validateLineitems(cartData,goToCheckout){
    window.cart_data = cartData;
    $.post(liSimply.interface,{
      shopid:liSimply.shopid,
      action:liSimply.actions.checkLineItems,
      data:cartData
    },
           function(dataObject){
      var data = $.parseJSON(dataObject);
      var unavailabelIndex = [];
      $.fancybox.hideLoading();
      if(data.status=="0"){
        bSuccess = true;
        $.each(data.data,function(index,item){
          window.product_db = item.product;
          if(window.product_db.data.tags.indexOf('no-delivery') != -1){
          }
          else{
            if(item.time){
              selectedtime = parseInt(item.time.split(':')[0]);
  
              var startEndObj = getStartEnd(item.date, window.current_hrs, window.current_minutes, index);
              // if(startEndObj.starting != startEndObj.ending){
                // if(startEndObj.starting <= startEndObj.ending){
                  if(selectedtime >= startEndObj.starting){
                    var qty = window.cart_data.items[index].quantity;
                    if(startEndObj.qty >= qty){
                    }
                    else{
                      console.log("else0")
                      bSuccess = false;
                      $('.cart-row[data-line='+index+'] .itemNotAvailabelMsg').removeClass('hidden').html('This item is not available in these number of quantity');
                    }
                  }
                  // else{
                  //   console.log("else1")
                  //   bSuccess = false;
                  //   $('.cart-row[data-line='+index+'] .itemNotAvailabelMsg').removeClass('hidden').html('This item is not available at selected date and time.');
                  // }
                // }
                // else{
                //   console.log("else2")
                //   bSuccess = false;
                //   $('.cart-row[data-line='+index+'] .itemNotAvailabelMsg').removeClass('hidden').html('This item is not available at selected date and time.');
                // }
              // }
              // else{
              //   console.log("else3")
              //   bSuccess = false;
              //   $('.cart-row[data-line='+index+'] .itemNotAvailabelMsg').removeClass('hidden').html('This item is not available at selected date and time.');
              // }
            }
          }
        });
  
        if(goToCheckout && bSuccess){
          location.href="/checkout";
        }
  
      }
    });
  } 

